import React,{ useState,useEffect } from 'react';
import { Card, CardBody,Col, Container, Row } from 'reactstrap';
import {useParams} from 'react-router-dom';
import ModelProduct from '../../Models/Products';
import ArticleQue from "./components/ArticleQue";
import ArticleQueFromSources from "./components/ArticleQueFromSources";
import IndexingQue from "./components/IndexingQue";


const Ques = () => {

    const { plink } = useParams();
    const mp = new ModelProduct();
    // const [pData,setData] = useState(null);
    const [isLoaded,setLoaded] = useState(false);

    useEffect(() => {
        console.log('rendering dah');

    },[]);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Ques</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12}>
                    <Row>
                        <ArticleQue />
                    </Row>
                </Col>
                <Col xs={12} sm={12}>
                    <Row>
                        <ArticleQueFromSources/>
                    </Row>
                </Col>
                <Col xs={12} sm={12}>
                    <Row>
                        <IndexingQue/>
                    </Row>
                </Col>

            </Row>
        </Container>
    );
}

export default Ques;